import { apiRequest } from './client';
import type {
  CancelExpenseInput,
  CreateExpenseInput,
  CreateExpenseSubcategoryInput,
  ExpenseCategory,
  ExpenseDetail,
  ExpenseListFilters,
  ExpenseListResponse,
  ExpenseSubcategory,
  ExpenseSummary,
  ExpenseSummaryFilters,
  UpdateExpenseInput,
} from '../types/expenses';

const PATH = '/api/expenses';

export const createExpense = (input: CreateExpenseInput) => apiRequest<{ expense: ExpenseDetail }>(PATH, json('POST', input));
export const getExpenses = (filters: ExpenseListFilters = {}) => apiRequest<ExpenseListResponse>(`${PATH}${toQuery(filters)}`);
export const getExpense = (id: string) => apiRequest<{ expense: ExpenseDetail }>(`${PATH}/${id}`);
export const updateExpense = (id: string, input: UpdateExpenseInput) => apiRequest<{ expense: ExpenseDetail }>(`${PATH}/${id}`, json('PATCH', input));
export const deleteExpenseDraft = (id: string) => apiRequest<{ ok: boolean }>(`${PATH}/${id}`, { method: 'DELETE' });
export const confirmExpense = (id: string) => apiRequest<{ expense: ExpenseDetail; message: string }>(`${PATH}/${id}/confirm`, { method: 'POST' });
export const cancelExpense = (id: string, input: CancelExpenseInput) => apiRequest<{ expense: ExpenseDetail; alreadyCancelled: boolean; message: string }>(`${PATH}/${id}/cancel`, json('POST', input));
export const getExpenseSummary = (filters: ExpenseSummaryFilters = {}) => apiRequest<ExpenseSummary>(`${PATH}/summary${toQuery(filters)}`);
export const getExpenseSubcategories = (category: ExpenseCategory) => apiRequest<{ items: ExpenseSubcategory[] }>(`${PATH}/subcategories${toQuery({ category })}`);
export const createExpenseSubcategory = (input: CreateExpenseSubcategoryInput) => apiRequest<{ subcategory: ExpenseSubcategory }>(`${PATH}/subcategories`, json('POST', input));

function json(method: string, body: unknown): RequestInit {
  return { method, body: JSON.stringify(body) };
}

function toQuery(filters: object) {
  const query = new URLSearchParams();
  Object.entries(filters).forEach(([key, value]) => { if (value !== undefined && value !== '') query.set(key, String(value)); });
  // Sin `URLSearchParams.size`: no existe en Chromium 83, el WebView de Android 11 (Bloque G).
  const search = query.toString();
  return search ? `?${search}` : '';
}
